export default {
  title: {
    en: 'Skip a month',
  },
  text: {
    en: 'Your next fragrance is scheduled to ship on {month}.<br /> How long do you want to pause?',
  },
  confirmButton: {
    en: 'Confirm',
  },
  back: {
    en: 'Back',
  },
}
